import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const startHalfRedoCheckoutAbTest = {
  name: "startHalfRedoCheckoutAbTest" as const,
  input: z.object({
    teamId: zExt.objectId(),
    checkoutExperienceId: zExt.objectId(),
  }),
  output: z.null(),
};
